import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Cookies from 'universal-cookie'
import Layout from '../Layout'
import WarningModal from '../components-modals/WarningModal'
import DatagridGroupedRows from './DatagridGroupedRows'
import { getReportes, setReportes_LastMonth } from '../../app/contaSlice'
import Container from '../components-layout/Container'
import ReportsForm from './ReportsForm'
import PieChart from './PieChart'
import Stats from './Stats'
import { dateFormatter } from './ReportsForm'
import Axios from 'axios'
import Resumenes from './Resumenes'

// const headers = {
//     "Authorization": process.env.REACT_APP_TOKEN_API,
//     "Content-ID": process.env.REACT_APP_AUDIENCIA_API,
//     "Content-Type": "application/json"
// }

let runInitialFetch = true

const Reportes = () => {
    const headersApi = useSelector((state) => state.url.headersAPI)

    const cookies = new Cookies()
    const urlSchoolApi = cookies.get('__urlSchoolApi')
    
    const urlConta = urlSchoolApi + '/finanzas/reportesingresos'
    
    const currentMMYY = getCurrentMonthRange()

    const initialParams = {
        Opcion: "0",
        FIni: currentMMYY.startDate,
        FFin: currentMMYY.endDate,
    }

    const configObj = {
        method: 'get',
        url: urlConta,
        headers: headersApi,
        params: initialParams,
    }

    const dispatch = useDispatch()

    useEffect(() => {
        if (runInitialFetch) {
            dispatch(getReportes(configObj))
        }
        runInitialFetch = false
    }, [runInitialFetch])


    const info = useSelector((state) => state.conta.info)
    //const lastMonthRange = getLastMonthRange()
    const currentYear = info?.FIni?.slice(0, 4)
    const currentMonth = info?.FIni?.slice(4, 6)
    const lastMonthRange = getLastMonthRange(currentYear, currentMonth)
    const lastMonthConfigObj = {
        method: 'get',
        url: urlConta,
        headers: headersApi,
        params: {
            Opcion: info.Opcion,
            FIni: lastMonthRange.startDate,
            FFin: lastMonthRange.endDate,
            IdEmpresa: (info.Opcion !== '0' ? info.IdEmpresa : null)
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await Axios(lastMonthConfigObj)
                if(response.data.length > 0){
                    dispatch(setReportes_LastMonth(response.data))
                }
                //dispatch(setReportes_LastMonth(response.data))
            } catch (err) {
                console.log(err)
            }
        }
        fetchData()
    }, [info])

    const [empresas, setBodegas] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            //setLoading(true);
            try {
                const res = await Axios({
                    method: 'GET',
                    url: urlSchoolApi + '/utils/busquedas',
                    headers: headersApi,
                    params: {
                        opcion: "EMPRESAS"
                    }
                })

                setBodegas(res.data);
                //setLoading(false);
            } catch (err) {
                console.log('error, recargar')
                window.location.reload()
                console.log(err)
            }
        }

        fetchData();
    }, [])

    const lastMonthRawData = useSelector(state => state.conta.reportes_LastMonth)

    const status = useSelector((state) => state.conta.ApiResponse)

    const title = getTitle(info.IdEmpresa, empresas)
    const year = info.FIni?.slice(0, 4)
    const month = info.FIni?.slice(4, -2)
    const monthES = monthFormatter(month, year)

    const user = useSelector(state => state.auth.user)
    const userObj = JSON.parse(user)

    const rawData = useSelector((state) => state.conta.reportes)

    const resumen = useSelector((state) => state.conta.resumen)
    const showResumen = useSelector((state) => state.conta.ShowResumen)

    return (
        <Layout userObj={userObj} activeTab='Análisis' >
            <WarningModal
                open={status === 'pending' ? true : false}
                image={<img src='./img/loader.gif' alt='loading' />}
                opacity='bg-opacity-100'
            />
            {/*<header className='p-5 text-white text-xl text-semibold'>
                Hola soy el encabezado
            </header>*/}
            <Container height='h-full'>
                <div className='h-full flex flex-col flex-wrap xl:grid xl:grid-cols-3 gap-5 pt-5 lg:pt-0'>
                    <div className='col-start-1 col-end-4 w-full h-full'>
                        <ReportsForm
                            empresas={empresas}
                            url={urlConta}
                            headers={headersApi}
                        />
                    </div>
                    <div className='sm:order-none col-start-1 col-end-4'>
                        <Stats
                            currentMonthData={rawData}
                            lastMonthData={lastMonthRawData}
                            title={title}
                            month={month}
                            year={year}
                        />
                    </div>
                    <div className='sm:order-none col-start-1 col-end-3 w-full h-full'>
                        <DatagridGroupedRows
                            title={title}
                            month={monthES}
                            year={year}
                            data={rawData}
                            url={urlConta}
                            headers={headersApi}
                        />
                    </div>
                    <div className='order-last sm:order-none col-start-3 col-end-4'>
                        <PieChart
                            title={title}
                            month={monthES}
                            year={year}
                            data={rawData}
                        />
                    </div>
                    <div className='sm:order-none col-start-1 col-end-4 w-full h-full'>
                        <Resumenes
                            title={title}
                            month={monthES}
                            year={year}
                            resumen={resumen}
                            showResumen={showResumen}
                        />
                    </div>
                </div>
            </Container>
        </Layout>
    )
}

const getTitle = (IdEmpresa = '', empresas = []) => {

    const result =  empresas.filter(emp => emp.IdEmpresa === IdEmpresa);

    if (result.length === 0) {
        return 'Todas las empresas'
    }

    return result[0].Empresa

    /*switch (empresa) {
        case undefined:
            return 'Todas las empresas'
        case 'COL':
            return 'Colegio de Informática IMB-PC, S.A.'
        case 'CEN':
            return 'Centro de Computación IMB-PC, S.A.'
        case 'PEC':
            return 'Personal C, S.A.'
        default:
            break
    }*/
}

export const getCurrentMonthRange = () => {
    const d = new Date()
    const mmyy = String(d.getFullYear()) + String(d.getMonth() + 1).padStart(2, '0')
    return dateFormatter(mmyy)
}

/*const getLastMonthRange = () => {
    const d = new Date()
    const mmyy = String(d.getFullYear()) + String(d.getMonth() - 1).padStart(2, '0')
    return dateFormatter(mmyy)
}*/

const getLastMonthRange = (year = '', month = '') => {
    const d = month && year
        ? new Date(year, Number(month) - 2)
        : new Date()

    //console.log(d)
    const mmyy = String(d.getFullYear()) + String(d.getMonth() + 1).padStart(2, '0')
    //console.log(mmyy)
    return dateFormatter(mmyy)
}

export const monthFormatter = (month, year) => {
    const strMonthES = new Date(Date.UTC(year, month)).toLocaleDateString('es-ES', { month: 'long' })
    return strMonthES.charAt(0).toUpperCase() + strMonthES.slice(1)
}

export default Reportes